// DS: i9.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const DollarSign: React.FC<Props> = props => (
  <IconWrap {...props} disableDefaultColors>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M11.34 20v-1.657q-1.26-.11-2.255-.564-.996-.454-1.555-1.287-.56-.833-.528-2.07l.02-.041h2.886q0 1.127.63 1.615t1.585.488q.924 0 1.412-.404.498-.412.498-1.102 0-.682-.478-1.11-.467-.43-1.615-.8-1.504-.454-2.49-.959-.975-.513-1.463-1.203-.477-.697-.477-1.716 0-1.413 1.087-2.313c.731-.606 1.51-.962 2.743-1.068V4h1.616v1.834c1.185.146 2.32.558 2.997 1.236q1.027 1.01 1.006 2.633l-.03.043h-2.886q0-.993-.498-1.531-.498-.54-1.341-.539-.875 0-1.31.42-.428.413-.428 1.103 0 .656.448 1.068.456.404 1.666.8 1.494.487 2.47 1.009.984.513 1.462 1.203.488.69.488 1.682 0 1.455-1.097 2.339-1.087.875-2.947 1.034V20z"></path>
    </svg>
  </IconWrap>
);
DollarSign.displayName = 'DollarSign';

export default DollarSign;
